import { render, staticRenderFns } from "./CardTabs.vue?vue&type=template&id=3bfaf1a3&functional=true&"
import script from "./CardTabs.vue?vue&type=script&lang=ts&"
export * from "./CardTabs.vue?vue&type=script&lang=ts&"
import style0 from "./CardTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports